import { createSlice } from "@reduxjs/toolkit";
import request from "../../service";
import Exported from "../../service/endpoints";

const initialState ={
    accessToken: null,
    sessionActive : false,
    userData : {},
    userPermission : [],
}
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        saveAccessToken: (state, action) => {
            state.accessToken = action.payload;
        },
        saveSessionActive : (state, action) =>{
            state.sessionActive = action.payload
        },
        saveUserData : (state, action) =>{
            state.userData = action.payload
        },
        saveUserPermission : (state, action) =>{
            state.userPermission = action.payload
        }
    },
});

export const login = (data) => {
    return request({
        url: Exported.Endpoints.login,
        method: Exported.APIMethods.POST,
        data,
    });
};

export const forgotPassword = (data) => {
    return request({
        url: Exported.Endpoints.forgotPassword,
        method: Exported.APIMethods.POST,
        data,
    });
};

export const createNewPassword = (data) => {
    return request({
        url: Exported.Endpoints.createNewpassword,
        method: Exported.APIMethods.POST,
        data,
    });
};
export const { saveAccessToken, saveSessionActive, saveUserData, saveUserPermission } = authSlice.actions;
export const access = (state) => state.auth.accessToken;
export const activeSession = (state) => state.auth.sessionActive;